import axiosInstance from '../api/axiosInstance';

export const FEATURE_FLAG_KEYS = Object.freeze({
  IS_ENABLED_BUSY_STATUS: 'isEnabledBusyStatus',
  // Whether the driver apps play video ads during a ride.
  IS_ENABLED_ADS: 'isEnabledAds',
});

export const loadFeatureFlags = async () => {
  const response = await axiosInstance.get('/feature_flags');
  return Array.isArray(response.data) ? response.data : [];
};

export const isFeatureFlagEnabled = (flags, flagKey) => {
  if (!Array.isArray(flags) || !flagKey) {
    return false;
  }

  const flag = flags.find((item) => item?.flag_key === flagKey);
  return flag?.enabled === true;
};
